'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dState from "./mealorama.-Store-Cart-State.js";
import * as $j_mealorama$002e$002dStore$002dCart$002dState$0024$0024anon$00241 from "./mealorama.-Store-Cart-State$$anon$1.js";
var $p;
function $s_Lmealorama_StoreCartState$__open__Lmealorama_StoreCartState() {
  $m_Lmealorama_StoreCartState$();
  return $t_Lmealorama_StoreCartState$__open;
}
export { $s_Lmealorama_StoreCartState$__open__Lmealorama_StoreCartState as $s_Lmealorama_StoreCartState$__open__Lmealorama_StoreCartState };
function $s_Lmealorama_StoreCartState$__paid__Lmealorama_StoreCartState() {
  $m_Lmealorama_StoreCartState$();
  return $t_Lmealorama_StoreCartState$__paid;
}
export { $s_Lmealorama_StoreCartState$__paid__Lmealorama_StoreCartState as $s_Lmealorama_StoreCartState$__paid__Lmealorama_StoreCartState };
function $s_Lmealorama_StoreCartState$__archived__Lmealorama_StoreCartState() {
  $m_Lmealorama_StoreCartState$();
  return $t_Lmealorama_StoreCartState$__archived;
}
export { $s_Lmealorama_StoreCartState$__archived__Lmealorama_StoreCartState as $s_Lmealorama_StoreCartState$__archived__Lmealorama_StoreCartState };
/** @constructor */
function $c_Lmealorama_StoreCartState$() {
  this.amc = null;
  $n_Lmealorama_StoreCartState$ = this;
  $t_Lmealorama_StoreCartState$__open = new $j_mealorama$002e$002dStore$002dCart$002dState$0024$0024anon$00241.$c_Lmealorama_StoreCartState$$anon$1("open", 0);
  $t_Lmealorama_StoreCartState$__paid = new $j_mealorama$002e$002dStore$002dCart$002dState$0024$0024anon$00241.$c_Lmealorama_StoreCartState$$anon$1("paid", 1);
  $t_Lmealorama_StoreCartState$__archived = new $j_mealorama$002e$002dStore$002dCart$002dState$0024$0024anon$00241.$c_Lmealorama_StoreCartState$$anon$1("archived", 2);
  this.amc = new ($j_mealorama$002e$002dStore$002dCart$002dState.$d_Lmealorama_StoreCartState.r().C)([$s_Lmealorama_StoreCartState$__open__Lmealorama_StoreCartState(), $s_Lmealorama_StoreCartState$__paid__Lmealorama_StoreCartState(), $s_Lmealorama_StoreCartState$__archived__Lmealorama_StoreCartState()]);
}
export { $c_Lmealorama_StoreCartState$ as $c_Lmealorama_StoreCartState$ };
$p = $c_Lmealorama_StoreCartState$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_StoreCartState$;
/** @constructor */
function $h_Lmealorama_StoreCartState$() {
}
export { $h_Lmealorama_StoreCartState$ as $h_Lmealorama_StoreCartState$ };
$h_Lmealorama_StoreCartState$.prototype = $p;
$p.aId = (function() {
  return this.amc.a6();
});
var $d_Lmealorama_StoreCartState$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_StoreCartState$, "mealorama.StoreCartState$", ({
  H8: 1,
  d: 1,
  S: 1
}));
export { $d_Lmealorama_StoreCartState$ as $d_Lmealorama_StoreCartState$ };
var $n_Lmealorama_StoreCartState$;
function $m_Lmealorama_StoreCartState$() {
  if ((!$n_Lmealorama_StoreCartState$)) {
    $n_Lmealorama_StoreCartState$ = new $c_Lmealorama_StoreCartState$();
  }
  return $n_Lmealorama_StoreCartState$;
}
export { $m_Lmealorama_StoreCartState$ as $m_Lmealorama_StoreCartState$ };
var $t_Lmealorama_StoreCartState$__open = null;
function $u_Lmealorama_StoreCartState$__open(x) {
  $t_Lmealorama_StoreCartState$__open = x;
}
export { $t_Lmealorama_StoreCartState$__open as $t_Lmealorama_StoreCartState$__open, $u_Lmealorama_StoreCartState$__open as $u_Lmealorama_StoreCartState$__open };
var $t_Lmealorama_StoreCartState$__paid = null;
function $u_Lmealorama_StoreCartState$__paid(x) {
  $t_Lmealorama_StoreCartState$__paid = x;
}
export { $t_Lmealorama_StoreCartState$__paid as $t_Lmealorama_StoreCartState$__paid, $u_Lmealorama_StoreCartState$__paid as $u_Lmealorama_StoreCartState$__paid };
var $t_Lmealorama_StoreCartState$__archived = null;
function $u_Lmealorama_StoreCartState$__archived(x) {
  $t_Lmealorama_StoreCartState$__archived = x;
}
export { $t_Lmealorama_StoreCartState$__archived as $t_Lmealorama_StoreCartState$__archived, $u_Lmealorama_StoreCartState$__archived as $u_Lmealorama_StoreCartState$__archived };
//# sourceMappingURL=mealorama.-Store-Cart-State$.js.map
